import React from 'react';
export function FilterIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.036 15.036l-9.19-.01a2.98 2.98 0 00-5.62-.01h-1.19a1 1 0 100 2h1.18a2.981 2.981 0 005.64.01l9.18.01a1 1 0 000-2zm-11.28 1.68l-.04.04a.972.972 0 01-1.36 0l-.04-.04a.972.972 0 010-1.36l.04-.04a.972.972 0 011.36 0l.04.04a.972.972 0 010 1.36zM20.046 7.056h-1.18a2.992 2.992 0 00-2.81-2.02h-.01a2.973 2.973 0 00-2.82 2.01l-9.18-.01a1 1 0 100 2l9.19.01c.142.418.378.798.69 1.11a2.938 2.938 0 002.12.88 3 3 0 002.81-1.98h1.19a1 1 0 100-2zm-3.29 1.66l-.04.04a.972.972 0 01-1.36 0l-.04-.04a.972.972 0 010-1.36l.04-.04a.972.972 0 011.36 0l.04.04a.972.972 0 010 1.36z"
  }));
}